import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from 'rebass'

const Title = ({ title }) => (
  <Heading.h1
    pl={[1, 2]}
    fontSize={[4, 5, 6]}
    style={{ borderLeft: `6px solid #FF0000` }}
  >
    {title}
  </Heading.h1>
)

Title.propTypes = {
  title: PropTypes.string,
}

Title.defaultProps = {
  title: `Section Title`,
}

export default Title



// WEBPACK FOOTER //
// ./src/containers/Section/Title.js